import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ILiquidationAddEditRequest } from '../../../../model/sge/liquidation/request/liquidation-add-edit-request';
import { ILiquidationPagedRequest } from '../../../../model/sge/liquidation/request/liquidation-paged-request';
import { ILiquidationResponse } from '../../../../model/sge/liquidation/response/liquidation-response';

const basePath = (commitmentId: number) => `Commitments/${commitmentId}/Liquidations`;

const list = async (commitmentId: number, params: Omit<ILiquidationPagedRequest, 'commitmentId'>): Promise<Pagination<ILiquidationResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(commitmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ILiquidationResponse>(), response.data));
};

const getById = async (commitmentId: number, id: number): Promise<ILiquidationResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(commitmentId)}/${id}`
    }).then((response) => response.data);
};

const add = async (commitmentId: number, params: ILiquidationAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${basePath(commitmentId)}`,
        data: params
    });
};

const edit = async (commitmentId: number, id: number, params: ILiquidationAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${basePath(commitmentId)}/${id}`,
        data: params
    });
};

const remove = async (commitmentId: number, id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${basePath(commitmentId)}/${id}`
    });
};

const LiquidationAppService = { list, getById, add, edit, remove };
export default LiquidationAppService;
